import clsx from 'clsx';
import { VideoPlayer } from '#common/components/VideoPlayer.tsx';

interface Props {
    /** Speaker/brand name SVG (shown as primary name, or larger line in two-line layout) */
    speakerNameSvg?: string | null;
    /** Voice name SVG (shown as single name in SEPARATE mode, or smaller line in SINGLE mode) */
    voiceNameSvg?: string | null;
    imageSrc: string;
    /** HLS manifest URL for the video (.m3u8) */
    videoHlsSrc?: string | null;
    /** HLS asset path for CloudFront signed cookie requests */
    videoHlsAssetPath?: string | null;
    showVideoIfAvailable?: boolean;
    size?: 'small' | 'large';
}

export function Portrait(
    { imageSrc, speakerNameSvg, voiceNameSvg, size = 'large', videoHlsSrc, videoHlsAssetPath, showVideoIfAvailable }:
        Props,
) {
    return (
        <div
            className={clsx(
                'relative mx-auto flex rounded-xl bg-slate-600 shadow-xl',
                'flex-col items-center justify-between bg-gradient-to-b from-slate-600 to-gray-900',
                'overflow-hidden',
                'px-6 pt-6 lg:px-12 lg:pt-12',
                'w-64 md:w-80',
                size == 'large' && 'lg:w-100 xl:w-120',
                'h-88 md:h-107',
                size == 'large' && 'lg:h-140 xl:h-168'
            )}
        >
            <div className='w-full flex justify-center'>
                <img
                    src='/images/CrispyVoice_Logo.png'
                    alt='CrispyVoice Logo'
                    className={clsx('h-12 md:h-16', size == 'large' && 'lg:h-24', 'w-auto object-contain')}
                />
            </div>
            {speakerNameSvg && voiceNameSvg
                ? (
                    <div className='text-white text-center w-full mt-2 mb-1 lg:mt-4 lg:mb-2 shrink-0'>
                        <div className='h-10 lg:h-16' dangerouslySetInnerHTML={{ __html: speakerNameSvg }} />
                        <div
                            className='h-6 lg:h-10 mt-1 opacity-70'
                            dangerouslySetInnerHTML={{ __html: voiceNameSvg }}
                        />
                    </div>
                )
                : (
                    <div
                        className='text-white text-center w-full h-12 lg:h-20
                           font-bold mt-2 mb-4 lg:mt-4 lg:mb-8 shrink-0'
                        dangerouslySetInnerHTML={{ __html: (speakerNameSvg || voiceNameSvg)! }}
                    />
                )}
            <div className='grow w-full' />
            {showVideoIfAvailable && videoHlsSrc
                ? (
                    <VideoPlayer
                        hlsSrc={videoHlsSrc}
                        hlsAssetPath={videoHlsAssetPath}
                        posterSrc={imageSrc}
                        autoPlay={true}
                    />
                )
                : (
                    <img
                        className='w-full flex justify-center object-contain'
                        style={{
                            maskImage: 'radial-gradient(circle at center, white 80%, transparent 100%)',
                            maskSize: 'cover'
                        }}
                        src={imageSrc}
                        alt='Profile Picture'
                    />
                )}
        </div>
    );
}
